import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { accountWatcher } from '@/model/account/kraken';
import VisibilityChange from '@/ports-frontend/VisibilityChange';

export const watchAccountActions = () =>
  asyncCallback(
    async (
      callback: Sender<
        | {
            type: 'VIEW_PROMOTIONS_EVENT_CALLED';
            payload: { [key: string]: any };
          }
        | {
            type: 'APP_VISIBILITY_HIDDEN';
          }
        | {
            type: 'APP_VISIBILITY_VISIBLE';
          }
      >
    ) => {
      VisibilityChange.onVisibilityChange(visibilityState => {
        if (visibilityState === 'hidden') {
          callback({ type: 'APP_VISIBILITY_HIDDEN' });
        } else {
          callback({ type: 'APP_VISIBILITY_VISIBLE' });
        }
      });

      return accountWatcher({ callback });
    }
  );
